<template>
  <div>
    <list :listTitle="$t('shopee.accounts.label')" :listLogo="definitionModule.logo" filterTitle="Filtros" :typesListAvailable="['displayList']" :loading="loadingSearch || loadingAddAccount" :total="shopeeAccountsTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" @change="onChange">
      <div class="btnGroup" slot="header-actions">
        <button @click="modalAddAccountFlag = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar conta">
          <i class="icon-plus"/>
        </button>
      </div>

      <template slot="filters">
        <form-group label="Nome">
          <input class="form-input" v-model="options.shopName">
        </form-group>
      </template>

      <div class="l-col-4@md" v-for="(item, index) in shopeeAccounts" :key="index">
        <account :account="item"/>
      </div>
      <div class="l-col u-textCenter" v-if="!shopeeAccounts.length">
        <panel>
          Nenhuma conta foi encontrada.
        </panel>
      </div>
    </list>
    <modal-account-confirmation :account="account" v-model="modalConfirmFlag" v-on:confirm="accountConfirm"/>
    <modal-add-account v-model="modalAddAccountFlag" v-on:confirm="shopeeAuthenticate"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { getAllUrlParams } from '@/helper'
  import { merge } from 'lodash'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import api from '@/api'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Account from '@/components/marketplace/shopee/Account'
  import ModalAccountConfirmation from '@/components/marketplace/shopee/ModalAccountConfirmation'
  import ModalAddAccount from '@/components/marketplace/shopee/ModalAddAccount'
  import moment from 'moment'

  export default {
    data: () => ({
      errors: [],
      loadingAddAccount: false,
      loadingSearch: false,
      type: 'marketplace',
      identifier: 'shopee',
      options: {
        shopName: ''
      },
      sortFields: [
        'shopName'
      ],
      account: null,
      modalConfirmFlag: false,
      modalAddAccountFlag: false,
      shop_id: null
    }),
    mounted () {
      this.addAccountByCodeAndShopId(getAllUrlParams().code, getAllUrlParams().shop_id)
      if (this.shopeeAccounts) {
        this.validateAccountsProductLimit()
        this.shopeeAccounts.forEach(account => {
          this.validateExpirationDate(account)
        })
      }
    },
    methods: {
      ...mapActions('shopeeAccounts', [
        'fetchAccounts',
        'addAccount'
      ]),
      validateExpirationDate (account) {
        if (moment(account.expirationDate).isBefore(moment())) {
          notifier.error('Conta ' + account.shopId + ' está com token desatualizado. Logue novamente em sua conta Shopee clicando no botão direito superior.', 'Token desatualizado')
        }
      },
      async validateAccountsProductLimit () {
        api.shopee.getAccountsProductLimits()
          .then(accounts => {
            if (accounts) {
              accounts.forEach(accountLimit => {
                notifier.error('Conta: ' + accountLimit.shopId + ' - Atual: ' + accountLimit.total + ' - Limite: ' + accountLimit.limit + '. Contate o suporte Shopee para registrar novos produtos', 'Limite de Produtos atingido')
              })
            }
          })
      },
      addAccountByCodeAndShopId (code, shopId) {
        if (code !== undefined && shopId !== undefined) {
          this.loadingAddAccount = true
          api.shopee.getAccount(code, shopId)
            .then(account => {
              this.loadingAddAccount = false
              this.account = account
              this.modalConfirmFlag = true
            })
            .catch(error => {
              let message = 'Falha ao adicionar a conta.'
              if (error.response.data.message) {
                message = error.response.data.message
              }
              notifier.error(message, 'Não adicionada')
              this.removeCode()
            })
            .finally(() => {
              this.loadingAddAccount = false
            })
        }
      },
      removeCode () {
        const currentUrl = window.location.href
        if (currentUrl.indexOf('?code') !== -1) {
          this.loading = true
          const url = currentUrl.replace(currentUrl.substr(currentUrl.indexOf('?'), 140), '')
          window.location.replace(`${url}#/marketplace/shopee/accounts`)
        } else {
          this.loading = false
        }
      },
      async shopeeAuthenticate () {
        const sellerAuth = await api.shopee.getAuthorization()

        window.location.href = `https://partner.shopeemobile.com/api/v2/shop/auth_partner?partner_id=${sellerAuth['partnerId']}&timestamp=${sellerAuth['timeStamp']}&redirect=http://panel.placemarket.com.br/%23/marketplace/shopee/accounts&sign=${sellerAuth['signature']}`
      },
      async onChange (options) {
        this.loadingSearch = true

        merge(this.options, options)

        await this.fetchAccounts({ options: this.options })

        this.loadingSearch = false
      },
      async accountConfirm () {
        this.loadingAddAccount = true
        await api.shopee.addAccount(this.account.refreshToken, this.account.shopId)
          .then(() => {
            notifier.success('Conta adicionada com sucesso.', 'Adicionada')
            this.fetchAccounts({ options: this.options })
              .then(() => {
                this.fetchAccounts({ options: this.options })

                this.loadingAddAccount = false
              })
          })
          .catch(error => {
            let message = 'Falha ao adicionar a conta.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Não adicionada')
            this.loadingAddAccount = false
          })
          .finally(() => {
            this.removeCode()
          })
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      ...mapFields({
        shopeeAccountsTotal: 'shopeeAccounts.total',
        shopeeAccounts: 'shopeeAccounts.accounts'
      }),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType(this.type, this.identifier)
      }
    },
    components: {
      ModalAccountConfirmation,
      ModalAddAccount,
      Loader,
      PageTitle,
      List,
      Panel,
      FormGroup,
      Account
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

    .logo
      max-height: 30px
      margin-right: 20px

      .title
        margin-top: 16px
        margin-left: 20px

      .paginator
        float: right
</style>



// WEBPACK FOOTER //
// List.vue?39656d86